export default __webpack_public_path__ + "static/media/regular-font.3e5c30ff.ttf";